import axios from "axios";
import * as rax from "retry-axios";
import { version } from "../../meta.json";

class TeleforceApi {
  request(method, route, endpoint, data) {
    return new Promise((resolve, reject) => {
      // create axios instance
      const axiosInstance = axios.create();
      // attach axios instance
      rax.attach(axiosInstance);
      const headers = {
        "X-Teleforce-Mobile": "6c8828b23b294774ba5ddd7551f56d25",
        "X-Teleforce-Workstation": "MOBILE",
        "X-Teleforce-App-Name": "supervisor-mobile",
        "X-Teleforce-App-Version": version
      };
      if (window.TELEFORCE_API_TOKEN) {
        headers["Authorization"] = `Bearer ${window.TELEFORCE_API_TOKEN}`;
      }
      if (window.TELEFORCE_USER_ID) {
        headers["X-Teleforce-User-ID"] = window.TELEFORCE_USER_ID;
      }
      // run axios
      axiosInstance({
        method,
        url: `https://console.teleforce.app/${route}/${endpoint}`,
        headers,
        data,
        raxConfig: {
          // Retry 3 times on requests that return a response (500, etc) before giving up.  Defaults to 3.
          retry: 3,
          // Retry twice on errors that don't return a response (ENOTFOUND, ETIMEDOUT, etc).
          noResponseRetries: 2,
          // Milliseconds to delay at first.  Defaults to 100.
          retryDelay: 100,
          // HTTP methods to automatically retry.  Defaults to:
          // ['GET', 'HEAD', 'OPTIONS', 'DELETE', 'PUT']
          httpMethodsToRetry: ["GET", "POST", "OPTIONS"],
          // The response status codes to retry.  Supports a double
          // array with a list of ranges.  Defaults to:
          // [[100, 199], [429, 429], [500, 599]]
          statusCodesToRetry: [
            [100, 199],
            [429, 429],
            [500, 599]
          ],
          // If you are using a non static instance of Axios you need
          // to pass that instance here (const ax = axios.create())
          instance: axiosInstance,
          // You can detect when a retry is happening, and figure out how many
          // retry attempts have been made
          onRetryAttempt: err => {
            const cfg = rax.getConfig(err);
            console.log(`Retry attempt #${cfg.currentRetryAttempt}`);
          }
        }
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }

  /**
   * Supervisor Login request
   * @param {string} supervisorId
   * @param {string} supervisorPassword
   * @returns {Promise<SupervisorLoginResponse>}
   */
  supervisorLogin(supervisorId, supervisorPassword) {
    return new Promise((resolve, reject) => {
      this.request("POST", "api/login", "supervisor", {
        supervisor_id: supervisorId,
        supervisor_password: supervisorPassword
      })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }
}

export default new TeleforceApi();
